var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifyPhoneAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 27,
    viewBox: "0 0 20 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 14.4444C6.27667 14.4444 3.05779 15.2967 1.45335 16.4567C0.467793 17.1689 0 18.0322 0 18.8889C0 19.7456 0.467793 20.6089 1.45335 21.3211C3.05779 22.4811 6.27667 23.3333 10 23.3333C13.7233 23.3333 16.9422 22.4811 18.5467 21.3211C19.5322 20.6089 20 19.7456 20 18.8889C20 18.0322 19.5322 17.1689 18.5467 16.4567C16.9422 15.2967 13.7233 14.4444 10 14.4444ZM10 0C6.32111 0 3.33333 2.98778 3.33333 6.66667C3.33333 10.3456 6.32111 13.3333 10 13.3333C13.6789 13.3333 16.6667 10.3456 16.6667 6.66667C16.6667 2.98778 13.6789 0 10 0Z",
    fill: "#132342"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2823 18.6602H7.76296C6.96904 18.6602 6.32397 19.3071 6.32397 20.101V26.3093C6.32397 26.4601 6.41558 26.5937 6.5549 26.649C6.6007 26.6662 6.64651 26.6757 6.6904 26.6757C6.78964 26.6757 6.88697 26.6356 6.95759 26.5593L8.26107 25.1642C8.45955 24.9543 8.73819 24.834 9.02636 24.834H13.2823C14.0762 24.834 14.7212 24.1871 14.7212 23.3932V20.101C14.7212 19.3071 14.0762 18.6602 13.2823 18.6602Z",
    fill: "url(#paint0_linear_5411_319)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5411_319",
    x1: 3.73499,
    y1: 29.4976,
    x2: 18.8118,
    y2: 19.8101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#401EF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FAEB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyPhoneAvatar);
export default __webpack_public_path__ + "static/media/verify-phone-avatar.32ea24c7d66d1a94bcc337823d4c6d71.svg";
export { ForwardRef as ReactComponent };